export default __webpack_public_path__ + "static/node-6af5da63c4a0e92a4712d3dc68150ec0.png";